import React from "react";
import AlertView from './view';
import { noop } from "@client/shared/constants";


const Alert = ({
  open = false,
  heading = "",
  content = "",
  positiveLabel = "Ok",
  negativeLabel = "Cancel",
  isLoading = false,
  hasCancel = true,
  preferenceName = '',
  preference = false,
  onCancel = noop,
  onSuccess = noop,
  handlePreference = noop,
}) => {
  return (
    <AlertView
      open={open}
      heading={heading}
      content={content}
      positiveLabel={positiveLabel}
      negativeLabel={negativeLabel}
      isLoading={isLoading}
      hasCancel={hasCancel}
      preferenceName={preferenceName}
      preference={preference}
      onCancel={onCancel}
      onSuccess={onSuccess}
      handlePreference={handlePreference}
    />
  )
};

export default Alert;